"use client";

import React from "react";
import { Instagram, MessageCircle, Music2 } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-5 w-24 bg-muted animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-muted-foreground hover:text-foreground transition-colors">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  return <section id="footer" className="dark bg-background text-foreground py-16 px-6 lg:px-8 border-t border-border">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {}
          <div className="space-y-6">
            <Link to="/">
              <img src="/img/paradise_palms_logo_dark.png" alt="Paradise Palms Jamaica Vacation rental" className="h-7 w-auto" />
            </Link>
            <address className="not-italic text-sm text-muted-foreground leading-relaxed">4 Wendy Close<br />Montego Bay, Jamaica</address>
          </div>

          {}
          <div>
            
            <MenuProvider menu_id="17">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            
            <div className="flex gap-4">
              <Link to="https://www.instagram.com/paradisepalmsmobay/" newTab className="flex items-center justify-center size-10 rounded-lg bg-muted hover:bg-accent hover:text-accent-foreground transition-colors" aria-label="Instagram">
                <Instagram className="size-5" />
              </Link>
              <Link to="#" className="flex items-center justify-center size-10 rounded-lg bg-muted hover:bg-accent hover:text-accent-foreground transition-colors" aria-label="TikTok">
                <Music2 className="size-5" />
              </Link>
              
            </div>
            <p className="mt-6 text-sm text-muted-foreground">
              Follow us for a glimpse of paradise.
            </p>
          </div>

          {}
          <div>
            
          </div>
        </div>

        <Separator className="mb-8" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
          <p>
            &copy; {new Date().getFullYear()} Paradise Palms Jamaica Vacation rental. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/PolicyPage" className="hover:text-foreground transition-colors">
              Cancellation Policy
            </Link>
          </div>
        </div>
      </div>
    </section>;
}